import { render } from "./PetNest.vue?vue&type=template&id=0f6967f4&scoped=true"
import script from "./PetNest.vue?vue&type=script&lang=js"
export * from "./PetNest.vue?vue&type=script&lang=js"

import "./PetNest.vue?vue&type=style&index=0&id=0f6967f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6967f4"]])

export default __exports__